var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "cartOverlay" } },
    [
      _c("span", {
        staticClass: "delete is-pulled-right has-background-grey",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("cart", { ref: "theCart" }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-warning is-small is-pulled-right top10",
          attrs: { disabled: _vm.$root.cartContents.length == 0 },
          on: { click: _vm.checkout }
        },
        [_vm._v("Checkout")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fed9c9a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fed9c9a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartOverlay.vue
// module id = null
// module chunks = 